import { createSlice } from '@reduxjs/toolkit';
import { LABELGENAPI } from '../../../API';
import axios from 'axios';
import { logFrontendActivity } from '../../General/activityLogger';

/* canceling previous requests if multiple requests is triggered */
const CancelToken = axios.CancelToken;
let source = CancelToken.source();

export const invoiceslice = createSlice({
    name: 'invoice',
    initialState: {
        invoiceData: {
            data: [],
            loading: false,
            meta: {
                page: 1,
                per_page: 10,
            },
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        invoiceDetail: {
            data: [],
            loading: false,
            meta: {
                page: 1,
                per_page: 10,
            },
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        instantCharge: {
            loading: false,
            notification: { show: false, messageContent: "", messageType: "success" }
        },
        invoiceSettings: {
            data: [],
            loading: false,
            notification: { show: false, messageContent: "", messageType: "success" }
        },
    },
    reducers: {
        getInvoice: (state) => {
            return {
                ...state,
                invoiceData: {
                    ...state.invoiceData,
                    data: [],
                    loading: true
                }
            }
        },
        getInvoiceSuccess: (state, action) => {
            return {
                ...state,
                invoiceData: {
                    ...state.invoiceData,
                    data: action && action.payload && action.payload.data && action.payload.data.data,
                    meta: action && action.payload && action.payload.data && action.payload.data.meta,
                    loading: false,
                    notification: { show: true, messageContent: action && action.payload && action.payload.data && action.payload.data.message && [action.payload.data.message], messageType: "success" }
                }
            }
        },
        getInvoiceFailure: (state, action) => {
            return {
                ...state,
                invoiceData: {
                    ...state.invoiceData,
                    loading: false,
                    notification: { show: true, messageContent: action && action.payload && action.payload.data && action.payload.data.message && [action.payload.data.message], messageType: "error" }
                }
            }
        },
        getInvoiceDetail: (state) => {
            return {
                ...state,
                invoiceDetail: {
                    ...state.invoiceDetail,
                    data: [],
                    loading: true
                }
            }
        },
        getInvoiceDetailSuccess: (state, action) => {
            return {
                ...state,
                invoiceDetail: {
                    ...state.invoiceDetail,
                    data: action && action.payload && action.payload.data && action.payload.data.data,
                    meta: action && action.payload && action.payload.data && action.payload.data.meta,
                    loading: false,
                    notification: { show: true, messageContent: action && action.payload && action.payload.data && action.payload.data.message && [action.payload.data.message], messageType: "success" }
                }
            }
        },
        getInvoiceDetailFailure: (state, action) => {
            return {
                ...state,
                invoiceDetail: {
                    ...state.invoiceDetail,
                    loading: false,
                    notification: { show: true, messageContent: action && action.payload && action.payload.data && action.payload.data.message && [action.payload.data.message], messageType: "error" }
                }
            }
        },
        postInstantCharge: (state) => {
            return {
                ...state,
                instantCharge: {
                    ...state.instantCharge,
                    loading: true
                }
            }
        },
        postInstantChargeSuccess: (state, action) => {
            return {
                ...state,
                instantCharge: {
                    ...state.instantCharge,
                    loading: false,
                    notification: { show: true, messageContent: action && action.payload && action.payload.data && action.payload.data.message && [action.payload.data.message], messageType: "success" }
                }
            }
        },
        postInstantChargeFailure: (state, action) => {
            return {
                ...state,
                instantCharge: {
                    ...state.instantCharge,
                    loading: false,
                    notification: { show: true, messageContent: action && action.payload && action.payload.data && action.payload.data.message && [action.payload.data.message], messageType: "error" }
                }
            }
        },
        getInvoiceSettings: (state) => {
            return {
                ...state,
                invoiceSettings: {
                    ...state.invoiceSettings,
                    loading: true
                }
            }
        },
        getInvoiceSettingsSuccess: (state, action) => {
            return {
                ...state,
                invoiceSettings: {
                    ...state.invoiceSettings,
                    loading: false,
                    data: action && action.payload && action.payload.data && action.payload.data.data,
                }
            }
        },
        getInvoiceSettingsFailure: (state, action) => {
            return {
                ...state,
                invoiceSettings: {
                    ...state.invoiceSettings,
                    data:[],
                    loading: false,
                }
            }
        },
        postInvoiceSettings: (state) => {
            return {
                ...state,
                invoiceSettings: {
                    ...state.invoiceSettings,
                    loading: true
                }
            }
        },
        postInvoiceSettingsSuccess: (state, action) => {
            return {
                ...state,
                invoiceSettings: {
                    ...state.invoiceSettings,
                    loading: false,
                    notification: { show: true, messageContent: action && action.payload && action.payload.data && action.payload.data.message && [action.payload.data.message], messageType: "success" }
                }
            }
        },
        postInvoiceSettingsFailure: (state, action) => {
            return {
                ...state,
                invoiceSettings: {
                    ...state.invoiceSettings,
                    loading: false,
                    notification: { show: true, messageContent: action && action.payload && action.payload.data && action.payload.data.message && [action.payload.data.message], messageType: "error" }
                }
            }
        },
        resetInvoiceNotification: (state, action) => {
            return {
                ...state,
                invoiceData: {
                    ...state.invoiceData,
                    notification: { show: false, messageContent: "", messageType: "success" }
                },
                invoiceDetail: {
                    ...state.invoiceDetail,
                    notification: { show: false, messageContent: "", messageType: "success" }
                },
                instantCharge: {
                    ...state.instantCharge,
                    notification: { show: false, messageContent: "", messageType: "success" }
                },
                 invoiceSettings: {
                    ...state.invoiceSettings,
                    notification: { show: false, messageContent: "", messageType: "success" }
                }
            }
        }


    }
})

export const { getInvoice, getInvoiceSuccess, getInvoiceFailure, 
    getInvoiceDetail, getInvoiceDetailSuccess, getInvoiceDetailFailure, resetInvoiceNotification, postInstantCharge, postInstantChargeSuccess, postInstantChargeFailure,
getInvoiceSettings,getInvoiceSettingsSuccess,getInvoiceSettingsFailure,postInvoiceSettings,
postInvoiceSettingsSuccess,postInvoiceSettingsFailure } = invoiceslice.actions;

export const fetchInvoice = (meta) => dispatch => {

    const qs = Object.keys(meta)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(meta[key])}`)
        .join('&');

    dispatch(getInvoice());
    try {
        source && source.cancel('Operation canceled due to new request.');
        source = axios.CancelToken.source();
        LABELGENAPI.get('/invoice/details?' + qs, {
            cancelToken: source.token
        }).then(function (response) {
            dispatch(getInvoiceSuccess(response));
        })
            .catch(function (error) {
                if (!axios.isCancel(error)) {
                    dispatch(getInvoiceFailure(error.response));
                }
            });
    } catch (error) {
        if (!axios.isCancel(error)) {
            dispatch(getInvoiceFailure(error.response));
        }
    }
};

export const fetchInvoiceDetail = (id, meta) => dispatch => {
    const qs = Object.keys(meta)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(meta[key])}`)
        .join('&');
    dispatch(getInvoiceDetail());
    try {
        source && source.cancel('Operation canceled due to new request.');
        source = axios.CancelToken.source();
        LABELGENAPI.get('/invoice/details/' + id + '?' + qs, {
            cancelToken: source.token
        }).then(function (response) {
            dispatch(getInvoiceDetailSuccess(response));
        })
            .catch(function (error) {
                if (!axios.isCancel(error)) {
                    dispatch(getInvoiceDetailFailure(error.response));
                }
            });
    } catch (error) {
        if (!axios.isCancel(error)) {
            dispatch(getInvoiceDetailFailure(error.response));
        }
    }
};

export const instantChargeInvoice = (data, meta) => dispatch => {
    dispatch(postInstantCharge());
    try {
        LABELGENAPI.post('payment/instant-charge', data)
            .then(function (response) {
                dispatch(postInstantChargeSuccess(response));
                dispatch(fetchInvoice(meta));
            }).catch(function (error) {
                dispatch(postInstantChargeFailure(error.response));
            })
    }
    catch (error) {
        dispatch(postInstantChargeFailure(error.response));
    }
}

export const fetchInvoiceSettings = () => dispatch => {
    dispatch(getInvoiceSettings());
    try {
        LABELGENAPI.get('settings/invoice-settings')
            .then(function (response) {
                dispatch(getInvoiceSettingsSuccess(response));
            }).catch(function (error) {
                dispatch(getInvoiceSettingsFailure(error.response));
            })
    }
    catch (error) {
        dispatch(getInvoiceSettingsFailure(error.response));
    }
}

export const updateInvoiceSettings = (userid,data) => dispatch => {
    dispatch(postInvoiceSettings());
    const logRef = crypto.randomUUID();
    try {
        LABELGENAPI.post('/settings/invoice-settings', data, { 
            headers: { 
                'x-log-ref': logRef
                 } 
            })
            .then(function (response) {
                dispatch(postInvoiceSettingsSuccess(response));
                dispatch(fetchInvoiceSettings());
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'INVOICE_SETTINGS_UPDATE',
                    action: 'SUCCESS',
                    request_data: data,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });
            }).catch(function (error) {
                dispatch(postInvoiceSettingsFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'INVOICE_SETTINGS_UPDATE',
                    action: 'FAILURE',
                    request_data: data,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                });
            })
    }
    catch (error) {
        dispatch(postInvoiceSettingsFailure(error.response));
        logFrontendActivity({
            group: 'SETTINGS',
            subgroup: 'INVOICE_SETTINGS_UPDATE',
            action: 'FAILURE',
            request_data: data,
            response_data: error.response?.data || {},
            log_ref: logRef,
            userid: userid
        }).then((ref) => {
            if (ref) {
                console.log('Activity log recorded with log_ref:', ref);
            }
        });
    }
}


export const resetInvoiceNotifications = () => {
    return (dispatch) => {
        dispatch(resetInvoiceNotification());
    }
}

export default invoiceslice.reducer;
